import {Spin} from 'antd';

export default () => <Spin><div style={{width: '100%', height: '100vh'}} /></Spin>;
